<template>
  <BasicModal
    :title="'ロボ作成'"
    :isShowModal="isCardModalActive"
    :canCancel="false"
    @cancel="cancel">
    <div class="card" style="border-radius: 5px;">
      <header class="card-header">
        <p class="card-header-title">
          ロボ作成
        </p>
        <div class="return-button-box">
          <button
            v-show="step === CREATE"
            class="button is-primary return-button"
            @click="step=INIT"
          >
            <span class="mdi mdi-undo" style="margin-right: 10px;"></span>
            戻る
          </button>
        </div>
      </header>
      <div class="card-content">
        <!-- 初期モード確認 -->
        <div class="init-box" v-if="step === INIT">
          <!-- 新規作成 -->
          <div class="make-bot-button" @click="step=CREATE">
            <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">新規作成</p>
            <p style="height: 200px; text-align: left;">ロボを新しく作成するモードです。上級者向けになります。</p>
            <img style="width: ; height: auto; object-fit: cover;" src="@/assets/template/create_make.png"/>
          </div>
          <!-- インポート -->
          <label for="file_upload" class="make-bot-button">
            <p style="font-weight: bold; font-size: 22px; margin-bottom: 15px;">インポート</p>
            <p style="height: 200px; text-align: left;">ロボをインポートし作成します。</p>
            <img style="width: 100%; height: auto; object-fit: cover;" src="@/assets/template/create_import.png"/>
            <input type="file" id="file_upload" @change="excelBotImport">
          </label>
        </div>
        <!-- 新規ロボ作成 -->
        <div class="card-content" v-if="step === CREATE">
          <p style="text-align: left; margin: 10px; position: relative;">
            <b>ロボ名を入力してください</b>
          </p>
          <div style="width: 100%; padding: 24px;">
            <div style="display: flex; width: 100%;">
              <p style="width: 200px; text-align: left;">
                名前：
              </p>
              <b-input style="width: calc(100% - 200px); margin-left: 24px;" v-model="inputs.name" maxlength="30"></b-input>
            </div>
            <div style="display: flex; width: 100%; margin-top: 16px;">
              <p style="width: 200px; text-align: left;">
                タグ設定：
              </p>
              <div style="margin-left: 24px;">
                <ChatBotTags
                  :chatbot="null"
                  :isEdit="true"
                  :isNew="true"
                  @changeTag="changeTag"/>
              </div>
            </div>
            <div style="display: flex; width: 100%; margin-top: 16px;" v-if="user.isAgent">
              <p style="width: 200px; text-align: left;">
                ミニロボの台数：<br>
                <span style="font-size: x-small; color: #777">同じような返答をするロボを複数台作成する場合は１以上にしてください。（後ほど変更もできます。）</span>
              </p>
              <b-numberinput controls-position="compact"
                min="0" max="150"
                v-model="miniBotCount"
                style="margin-left: 24px;">
              </b-numberinput>
            </div>
          </div>
        </div>
      </div>
      <div v-if="step === 'init'" class="card-footer">
        <a class="card-footer-item" @click="cancel()">キャンセル</a>
      </div>
      <div v-else class="card-footer">
        <a class="card-footer-item" @click="cancel()">キャンセル</a>
        <a class="card-footer-item" @click="clickCreateRobo()" :disabled="isSubmitting">作成する</a>
      </div>
    </div>
  </BasicModal>
</template>

<script>
import { mapState }    from 'vuex'
import createUUID      from '@/functions/createUUID'
import BasicModal      from '@/components/Modals/BasicModal'
import ChatBotTags     from '@/components2/Common/Screen/organisms/ChatBotTags'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'RoboCreate',
  componentName: 'RoboCreate',
  components: {
    BasicModal,
    ChatBotTags,
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user']),
  },
  props: {
    /**
     * ダイアログ開閉フラグ
     * @type  {Object}
     */
    isCardModalActive: {
      type: Boolean,
      default: false,
      required: true
    },
  },
  watch: {
    step: function(){
      // 戻るボタン押下時に値が初期化されないので、watchで監視して初期化する
      if(this.step === 'init'){
        this.miniBotCount = 0
        this.createTags = []
        this.inputs.name =''
      }
    }
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type  {String}
       */
      COMPONENT_NAME: 'RoboCreate',
      /**
       * 遷移ステップ
       * @type  {Number}
       */
      INIT: 'init',
      CREATE: 'create',
      IMPORT: 'import',
      step: 'init',
      /**
       * タグ
       * @type {Array}
       */
      createTags: [],
      /**
       * 新規ロボ初期情報
       * @type  {Object}
       */
      inputs: {
        /**
         * ロボ管理名
         * @type  {String}
         */
        name: '',
        /**
         * ロボ表示名
         * @type  {String}
         */
        display_name: '',
        /**
         * 会社ID
         * @type  {String}
         */
        group: null,
        /**
         * シナリオID
         * @type  {String}
         */
        scenario_name: '',
        /**
         * 未使用項目
         * @type  {Number}
         */
        left: 0,
        /**
         * 未使用項目
         * @type  {Number}
         */
        used_hours: 0,
        /**
         * ロボ表示順
         * @type  {Number}
         */
        order_num: 0,
        /**
         * テンプレートフラグ
         * @type  {Number}
         */
        is_store: false,
        /**
         * 編集者
         * @type  {Number}
         */
        editor: [],
        /**
         * タグ
         * @type  {Number}
         */
        tags: []
      },
      miniBotCount: 0,
      isSubmitting: false
    }
  },
  mounted () {
    // 初期化
    this.miniBotCount = 0
    this.createTags = []
  },
  methods: {
    /**
     * バイナリデータを型つき配列((Uint8Array)に変換
     * @param  {Array} data Excelデータ配列
     * @return {Uint8Array} 型つき配列
     */
    fixdata (data) {
      let o = ''
      let l = 0
      let w = 10240
      for (; l < data.byteLength / w; ++l) {
        o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)))
      }
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)))
      return o
    },
    /**
     * ロボインポート
     * @param  {Event} event ファイル選択オブジェクト
     */
    excelBotImport (event) {
      // Excelファイルを読み込み
      let files = event.target.files || event.dataTransfer.files
      let reader = new FileReader()
      reader.onload = (event) => {
        let XLSX = require('xlsx')
        let Utils = XLSX.utils
        let arr = this.fixdata(event.target.result)
        let book = XLSX.read(btoa(arr), {
          type: 'base64',
          cellDates: true,
        })
        let urlListsSheet1 = book.Sheets['TOP']
        let urlListsSheet2 = book.Sheets['BOT']
        let henkan1 = Utils.sheet_to_json(urlListsSheet1)
        let version = henkan1.find(data => data.__rowNum__ == 1)
        henkan1 = henkan1.filter(data => data.__rowNum__ != 1)
        version = version ? version['__EMPTY_9'] : ''
        let henkan2 = Utils.sheet_to_json(urlListsSheet2)
        let dataJson = {
          'version'  : version,
          'bot'      : henkan1,
          'scenario' : henkan2
        }

        // Excelファイルからロボをインポート
        this.sendControlLogRelatedChatBot('ロボインポート', 'ロボ新規作成にて、ロボのインポートを行った。', this.inputs.name)
        this.$store.dispatch('chatbot/importBot', dataJson)
      }
      reader.readAsArrayBuffer(files[0])

      // 遷移状態を初期化
      this.step = this.INIT
      // ダイアログを閉じる
      this.cancel()
    },
    /**
     * タグ設定
     */
    changeTag (tags) {
      this.createTags = tags
    },
    /**
     * ロボ新規作成
     */
    clickCreateRobo () {
      if (!this.inputs.name) {
        // ロボ名が入力されていない場合はエラー
        alert('ロボ名を入力してください')
        return
      }
      if (this.createTags.length <= 0) {
        // タグが入力されていない場合はエラー
        alert('タグを入力してください')
        return
      }
      if (this.miniBotCount > 150){
        // ミニロボの作成台数が150台を超える場合はエラー
        alert('ミニロボの作成台数は150台以下をご指定ください')
        return
      }

      // 送信中フラグをtrueに設定
      this.isSubmitting = true

      // シナリオID作成
      this.inputs.scenario_name = createUUID()
      // 会社ID設定
      this.inputs.group = this.user.companyID
      // 編集者として作成者を追加
      this.inputs.editor.push(this.user.userHash)
      // タグを設定
      for (const tag of this.createTags) {
        this.inputs.tags.push(tag.pk)
      }

      this.sendControlLogRelatedChatBot('ロボ新規作成', 'ロボ新規作成にて、ロボの作成を行った。', this.inputs.name)
      // ロボ表示名に入力されたロボ名を設定
      this.inputs.display_name = this.inputs.name
      // ロボを作成
      this.$store.dispatch('chatbot/createChatBot', JSON.parse(JSON.stringify(this.inputs)))
        .then((newRobo) => {
          // 設定された台数分のミニロボを作成する
          for (let index = 0; index < this.miniBotCount; index++) {
            let createChatBotMiniTemp = {
              name            : newRobo.name + Number(index + 1),
              chatbot         : newRobo.bot_id,
              target_url      : null,
              start_url       : null,
              working_hours   : newRobo.working_hours,
              is_recruit      : false,
              is_permitted    : false,
              permit_users    : null,
              send_power      : 0,
              select_power    : 0,
              receive_power   : 0,
              subscribe_power : 0
            }
            // ミニロボを作成
            this.$store.dispatch('chatbot/createChatBotMini', createChatBotMiniTemp)
          }
          // シナリオ編集画面内での遷移も考慮して編集中の情報をクリアする
          this.$store.dispatch('chatbot/scenarioPastCancel')
          this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
          // 作成したロボのシナリオを取得(新規なのでシナリオなし)して、シナリオ編集画面で選択状態にする
          this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: newRobo.scenario_name })
          this.$store.dispatch('chatbot/selectChatbot', newRobo)
          // 作成したロボのシナリオ編集画面に遷移する
          this.$router.push('/client/chatbot?view=scenario&scenario=' + newRobo.scenario_name)

          // ダイアログを閉じる
          this.cancel()
        })
        .catch((error) => {
          console.error('ロボ作成エラー:', error)
          alert('作成中にエラーが発生しました。もう一度お試しください。')
        })
        .finally(() => {
          // 処理完了後、送信中フラグをfalseに戻す
          this.isSubmitting = false
        })
    },
    /**
     * キャンセル
     */
    cancel () {
      this.dataClear()
      this.$emit('cancel', false)
    },
    dataClear () {
      // 遷移状態を初期化
      this.step = this.INIT
      // 画面上のデータを初期化
      this.inputs.name = ''
      this.inputs.display_name = '',
      this.inputs.group = null,
      this.inputs.scenario_name = '',
      this.inputs.left = 0,
      this.inputs.used_hours = 0,
      this.inputs.order_num = 0,
      this.inputs.is_store = false,
      this.inputs.editor = [],
      this.inputs.tags = []
      this.miniBotCount = 0
      this.createTags = []
      this.isSubmitting = false
    }
  }
}
</script>

<style scoped>
.init-box {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.make-bot-button {
  height: 400px;
  width: calc(50% - 30px);
  margin: 10px 10px;
  cursor: pointer;
  border: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  color: white;
  position: relative;
  padding: 20px;
  border-radius: 15px;
  background-color: rgba(144, 37, 98);
  /* transition: 0.5s; */
}
.make-bot-button > input {
  display: none;
}
.make-bot-button:hover {
  transform: scale(1.05);
}
.return-button-box {
  padding: 8px;
  padding-right: 32px;
}
.return-button {
  /* top: -110px; */
  height: 32px;
  position: absolute;
  right: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/RoboCreate.vue